"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.framesLogQueue = exports.FramesLogQueue = void 0;
var frameStart_1 = require("../../metadata/frameStart");
var framedevent_1 = require("@snapchat/ts-protos/data/framedevent");
var logger_1 = require("../../logger");
var event_1 = require("../event");
var strings_1 = require("../../util/strings");
var transmit_1 = require("../../network/transmit");
var json_1 = require("../json");
var environment_1 = require("../../environment");
var typeUtils_1 = require("../../util/typeUtils");
var config_1 = require("../../config");
var grapheneMetrics_1 = require("../../grapheneMetrics");
var TIER0EventSet = new Set(["WEB_PAGE_OPEN"]);
var FramesLogQueue = (function () {
    function FramesLogQueue(logQueueName) {
        this.sequenceId = 1;
        this.eventBuffer = [];
        this.eventBufferNameList = [];
        this.timeoutId = undefined;
        this.clientReferenceTs = -1;
        this.flushEnabled = false;
        this.logQueueName = logQueueName;
        this.log = (0, logger_1.getLogger)("protoQueue.".concat(logQueueName));
    }
    FramesLogQueue.prototype.append = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, config_1.isBatchingEnabled)()];
                    case 1:
                        if (_a.sent()) {
                            this.appendWithBatching(item);
                        }
                        else {
                            this.appendWithoutBatching(item);
                        }
                        return [2];
                }
            });
        });
    };
    FramesLogQueue.prototype.appendWithoutBatching = function (item) {
        if ((0, frameStart_1.isFrameStart)(item)) {
            this.log.trace("Saw new FrameStart, converting/copying for this queue");
            this.lastFrameStart = convertFrameStart(this.logQueueName, item);
        }
        else if ((0, event_1.isEvent)(item)) {
            var frameStart = this.lastFrameStart
                ? framedevent_1.FrameStart.fromPartial(this.lastFrameStart)
                : null;
            if (!frameStart) {
                throw new Error("Event before FrameStart");
            }
            var offsetTs = (0, typeUtils_1.blizzardTimestampToMs)(item.metadata.client_ts);
            var sequenceId = this.sequenceId++;
            frameStart.sequenceIdStart = sequenceId;
            frameStart.clientReferenceTs = offsetTs.toString();
            var event_2 = convertEvent(item, sequenceId, offsetTs);
            (0, transmit_1.transmitProtoEvents)(frameStart, [event_2]);
        }
        else {
            throw new Error("Illegal item: " + item);
        }
    };
    FramesLogQueue.prototype.appendWithBatching = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var event_3;
            return __generator(this, function (_a) {
                try {
                    this.flushEnabled = true;
                    if ((0, frameStart_1.isFrameStart)(item)) {
                        this.log.debug("Saw new FrameStart, converting/copying for this queue");
                        if (this.lastFrameStart) {
                            this.flush("frame_start_changed");
                        }
                        this.lastFrameStart = convertFrameStart(this.logQueueName, item);
                    }
                    else if ((0, event_1.isEvent)(item)) {
                        if (!this.lastFrameStart) {
                            grapheneMetrics_1.blizzardGraphene.increment({
                                metricsName: grapheneMetrics_1.LOG_EVENT_BEFORE_FRAME_START
                            });
                            throw new Error("Event before FrameStart");
                        }
                        if (this.eventBuffer.length === 0) {
                            this.clientReferenceTs = (0, typeUtils_1.blizzardTimestampToMs)(item.metadata.client_ts);
                            this.lastFrameStart.sequenceIdStart = this.sequenceId;
                            this.lastFrameStart.clientReferenceTs = this.clientReferenceTs.toString();
                        }
                        event_3 = convertEvent(item, this.sequenceId++, this.clientReferenceTs);
                        this.eventBuffer.push(event_3);
                        this.eventBufferNameList.push(item.eventName);
                        this.maybeFlushAfterAppend(TIER0EventSet.has(item.eventName));
                    }
                    else {
                        grapheneMetrics_1.blizzardGraphene.increment({
                            metricsName: grapheneMetrics_1.LOG_EVENT_ILLEGAL_ITEMS
                        });
                        throw new Error("Illegal item: " + item);
                    }
                }
                catch (e) {
                    grapheneMetrics_1.blizzardGraphene.increment({
                        metricsName: grapheneMetrics_1.LOG_EVENT_APPEND_ERROR
                    });
                    this.log.error(e);
                }
                return [2];
            });
        });
    };
    FramesLogQueue.prototype.maybeFlushAfterAppend = function (isTIER0Present) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isTIER0Present) return [3, 1];
                        this.flush("tier0_event_present");
                        return [3, 3];
                    case 1:
                        _a = this.eventBuffer.length;
                        return [4, (0, config_1.batchingSizeLimit)()];
                    case 2:
                        if (_a >= (_b.sent())) {
                            this.flush("batch_size_limit_reached");
                        }
                        else {
                            this.startFlushTimer();
                        }
                        _b.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    FramesLogQueue.prototype.flush = function (reason) {
        try {
            if (!this.flushEnabled) {
                return;
            }
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.LOG_EVENT_FLUSH,
                dimensions: {
                    reason: reason,
                    status: "attempt"
                }
            });
            this.log.debug("Flush starts. Reason: ", reason);
            if (!this.shouldFlush()) {
                return;
            }
            var frameStart = this.lastFrameStart;
            var eventsToTransmit = __spreadArray([], __read(this.eventBuffer), false);
            this.eventBuffer = [];
            (0, transmit_1.transmitProtoEvents)(frameStart, eventsToTransmit);
            this.logMetricsAfterFlush(eventsToTransmit.length, Math.round(performance.now() - this.clientReferenceTs));
            this.clearFlushTimer();
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.LOG_EVENT_FLUSH,
                dimensions: {
                    reason: reason,
                    status: "success"
                }
            });
        }
        catch (e) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.LOG_EVENT_FLUSH_ERROR
            });
            this.log.error(e);
        }
    };
    FramesLogQueue.prototype.startFlushTimer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeoutToFlushMillsecs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, config_1.batchingUploadTimeout)()];
                    case 1:
                        timeoutToFlushMillsecs = _a.sent();
                        if (this.timeoutId === undefined) {
                            this.timeoutId = setTimeout(function () {
                                _this.flush("timeout");
                            }, timeoutToFlushMillsecs);
                        }
                        return [2];
                }
            });
        });
    };
    FramesLogQueue.prototype.clearFlushTimer = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    };
    FramesLogQueue.prototype.shouldFlush = function () {
        if (this.eventBuffer.length === 0) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.LOG_EVENT_EMPTY_BATCH_AT_FLUSH
            });
            this.log.debug("Flush receives empty eventBuffer. Do nothing and return.");
            return false;
        }
        if (!this.lastFrameStart) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.LOG_EVENT_NO_FRAME_START_AT_FLUSH
            });
            throw new Error("No frameStart when flushing");
        }
        return true;
    };
    FramesLogQueue.prototype.logMetricsAfterFlush = function (bufferSize, flushTimeMilliSec) {
        var _a;
        grapheneMetrics_1.blizzardGraphene.addHistogram({
            metricsName: grapheneMetrics_1.LOG_EVENT_BATCHING_BUFFER_SIZE,
            value: bufferSize
        });
        for (var i = 0; i < this.eventBufferNameList.length; i++) {
            this.log.debug(this.eventBufferNameList[i], " is uploaded.");
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.EVENTS_FLUSHED,
                dimensions: {
                    name: this.eventBufferNameList[i],
                    app: (_a = (0, environment_1.getAppEnvironment)().application) !== null && _a !== void 0 ? _a : ""
                }
            });
        }
        this.eventBufferNameList = [];
        grapheneMetrics_1.blizzardGraphene.addTimer({
            metricsName: grapheneMetrics_1.LOG_EVENT_BATCH_LIFETIME_TILL_FLUSH_MS,
            milliSec: Math.round(flushTimeMilliSec)
        });
    };
    return FramesLogQueue;
}());
exports.FramesLogQueue = FramesLogQueue;
exports.framesLogQueue = new FramesLogQueue("w");
function convertFrameStart(logQueueName, frameStart) {
    var _a, _b;
    return framedevent_1.FrameStart.fromPartial({
        logQueueName: (0, strings_1.stringToBytes)(logQueueName),
        userAgent: (0, strings_1.stringToBytes)(frameStart.user_agent),
        localeFallback: frameStart.locale,
        osType: frameStart.os_type
            ? (_a = osTypeMap[frameStart.os_type]) !== null && _a !== void 0 ? _a : framedevent_1.OperatingSystem.OPERATING_SYSTEM_OTHER
            : undefined,
        osVersionString: frameStart.os_version,
        appType: (_b = (frameStart.app_type ? appTypeMap[frameStart.app_type] : undefined)) !== null && _b !== void 0 ? _b : framedevent_1.AppType.APP_TYPE_UNKNOWN,
        appBuildFallback: (0, strings_1.stringToBytes)(frameStart.app_build),
        appVersionString: frameStart.app_version,
        browser: frameStart.browser,
        browserVersion: frameStart.browser_version,
        deviceModelFallback: frameStart.device_model,
        domain: frameStart.domain,
        referrer: frameStart.referrer,
        clientId: (0, strings_1.stringToBytes)(frameStart.client_id),
        sessionId: (0, strings_1.stringToBytes)("f." + frameStart.session_id),
        appStartupTypeFallback: (0, strings_1.stringToBytes)(frameStart.app_startup_type),
        userGuid: (0, strings_1.stringToBytes)(frameStart.user_guid)
    });
}
function convertEvent(event, sequenceId, offsetTs) {
    var _a, _b;
    return framedevent_1.Event.fromPartial(__assign(__assign({ offsetTsStart: (0, typeUtils_1.blizzardTimestampToMs)(event.metadata.client_ts) - offsetTs, sequenceNumber: sequenceId }, extractEventData(event.data)), { deviceConnectivity: (_a = (event.metadata.device_connectivity && connectivityMap[event.metadata.device_connectivity])) !== null && _a !== void 0 ? _a : framedevent_1.ConnectivityType.UNKNOWN_CONNECTIVITY_TYPE, connectionDownloadBandwidthBps: (_b = event.metadata.connection_download_bandwidth_bps) === null || _b === void 0 ? void 0 : _b.toString() }));
}
function extractEventData(data) {
    if ((0, event_1.isProtoEventData)(data)) {
        return {
            payloadIdentifier: data.payloadIdentifier,
            payloadProto: data.toProto(),
            eventSamplingRate: Math.max(FIXED_SAMPLING_RATE, data.perEventSamplingRate),
            userSamplingRate: Math.max(FIXED_SAMPLING_RATE, data.perUserSamplingRate)
        };
    }
    else {
        return {
            payloadJson: (0, strings_1.stringToBytes)((0, json_1.stringifyBlizzardJson)(data)),
            eventSamplingRate: FIXED_SAMPLING_RATE,
            userSamplingRate: FIXED_SAMPLING_RATE
        };
    }
}
var osTypeMap = {
    IOS: framedevent_1.OperatingSystem.IOS,
    ANDROID: framedevent_1.OperatingSystem.ANDROID,
    WINDOWS: framedevent_1.OperatingSystem.OPERATING_SYSTEM_WINDOWS,
    OSX: framedevent_1.OperatingSystem.OPERATING_SYSTEM_OSX,
    "CHROME OS": framedevent_1.OperatingSystem.OPERATING_SYSTEM_CHROMIUM_OS,
    "CHROMIUM OS": framedevent_1.OperatingSystem.OPERATING_SYSTEM_CHROMIUM_OS,
    CHROMIUM_OS: framedevent_1.OperatingSystem.OPERATING_SYSTEM_CHROMIUM_OS,
    CHROME_OS: framedevent_1.OperatingSystem.OPERATING_SYSTEM_CHROMIUM_OS
};
var connectivityMap = {
    WIFI: framedevent_1.ConnectivityType.WIFI,
    MOBILE: framedevent_1.ConnectivityType.MOBILE,
    UNREACHABLE: framedevent_1.ConnectivityType.UNREACHABLE,
    BLUETOOTH: framedevent_1.ConnectivityType.BLUETOOTH,
    ETHERNET: framedevent_1.ConnectivityType.CONNECTIVITY_TYPE_ETHERNET
};
var appTypeMap = {
    WEB_DESKTOP: framedevent_1.AppType.APP_TYPE_WEB_DESKTOP,
    WEB_MOBILE: framedevent_1.AppType.APP_TYPE_WEB_MOBILE
};
var FIXED_SAMPLING_RATE = 1;
//# sourceMappingURL=framesLogQueue.js.map